export default "__VITE_ASSET__DSMIVONj__"